import { Schema } from 'rsuite';

const { StringType } = Schema.Types;

const validationModel = Schema.Model({
  label: StringType()
    .isRequired('Label is required.')
    .maxLength(200, 'Max 200 characters.'),

  individualPeriod: StringType(),

  corporatePeriod: StringType(),

  name: StringType()
    .isRequired('Name is required.')
    .maxLength(200, 'Max 200 characters.'),

  street: StringType()
    .isRequired('Street is required.')
    .maxLength(200, 'Max 200 characters.'),

  postCode: StringType()
    .isRequired('Postal code is required.'),

  city: StringType()
    .isRequired('City is required.')
    .maxLength(200, 'Max 200 characters.'),

  countryCode: StringType()
    .isRequired('Country code is required.'),

  description: StringType()
    .maxLength(10240, 'Max 10240 characters.'),
});

export default validationModel;
